/**
 * Checks if the sectionId exists in list of classes
 * @param {string} sectionId
 * @param {array} classes
 * @returns {boolean} If the class was found
 * */
const isTeacherTeachingClass = ({ sectionId, classes }) => {
  if (!sectionId || !Array.isArray(classes) || !classes.length) return false;

  const foundClass = classes.find(({ id }) => id === sectionId);

  return Boolean(foundClass);
};

export default isTeacherTeachingClass;
